import { render, staticRenderFns } from "./TherapistDetails.vue?vue&type=template&id=16c5fbc2&"
import script from "./TherapistDetails.vue?vue&type=script&lang=js&"
export * from "./TherapistDetails.vue?vue&type=script&lang=js&"
import style0 from "./TherapistDetails.vue?vue&type=style&index=0&id=16c5fbc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports